import { MessageSquareCheck } from 'lucide-react'

import { Banner } from '@/components/ui/banner'
import { Button } from '@/components/ui/button'
import { CUSTOMER_QUOTES_TAB, customerTabHref } from '@/lib/customerTabs'

/** Closes the transcript staff read once the customer has moved on to their quotes page. */
export function ChatEndedNotice({ orgId }: { orgId: string }) {
  return (
    <Banner
      small
      align="center"
      icon={<MessageSquareCheck />}
      action={
        <Button href={customerTabHref(orgId, CUSTOMER_QUOTES_TAB)} variant="outline" size="sm">
          View quotes
        </Button>
      }
    >
      <strong>Chat ended.</strong> The customer moved on to quotes and no longer sees this chat.
    </Banner>
  )
}
